import ReactDOM from 'react-dom';
import 'bootstrap/dist/js/bootstrap.bundle.min';

import { App } from './App';
import './styles/styles.scss';
import './styles/font-icons.css';
import './i18n/i18n';

ReactDOM.render(<App />, document.getElementById('wrapper'));
